module.exports = __webpack_public_path__ + "static/entrance_3-e2c0124268e522d01046ff93c1a8af01.jpg";